// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import {
  AnimatedView,
  StatsTable,
  ScoreCard,
  GameTypeTab,
  StatsGraph,
  AllGametypeTab
}                         from '../../../../components';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import { withRouter } from 'react-router';
  import Dialog from 'material-ui/Dialog';
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import ReactTable from "react-table"; 
  import { Link }         from 'react-router-dom';
  
  
  class TicketStatus extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        venue: props.props.statsTable.revenue_per_month.requested_venue_id,
        open_tickets : [],
        close_tickets : [],
        selected_values : [],
        is_open_ticket_checked : true,
        selected_ticket : [],
        open_close_dialog : false,
        open_edit_dialog : false,
        open_comments_dialog : false,
        priority_arr : [],
        buddies_arr : [],
        comment : '',
        edit_details: {
          assigned_to: '',
          priority: 0
        }
        
      };
      this.handleChange = this.handleChange.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
      this.handleEditChange = this.handleEditChange.bind(this)
      this.showOpenTickets = this.showOpenTickets.bind(this)
      this.closeTicket = this.closeTicket.bind(this)
      this.editTicket = this.editTicket.bind(this)
      this.handleEdit = this.handleEdit.bind(this)
    }
  
    componentDidMount() {
        this.getTickets();
        this.getBuddies()
    }

    locationChanged() {
    this.setState({venue:this.props.props.statsTable.revenue_per_month.requested_venue_id}, () => {
      this.getTickets()  
    })
    }

    handleClose = () => {
      this.setState({open_close_dialog:false});
    };

    handleOpen=()=>{
      this.setState({open_close_dialog:true})
    }  

    handleEditClose = () => {
      this.setState({open_edit_dialog:false});
    };

    handleEditOpen=()=>{
      this.setState({open_edit_dialog:true})
    }   

    handleCommentsClose = () => {
      this.setState({open_comments_dialog:false});
    };

    getTickets(){
    const url = `${getLocationOrigin()}/support/get_tickets_for_buddy/?venue=${this.state.venue}`;
     const options = {...defaultOptions};
     console.log('getTickets')

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({open_tickets:data.result.open_tickets,close_tickets:data.result.close_tickets,selected_values:data.result.open_tickets, priority_arr:data.result.priority});
           // alert("fix");
       }).catch(error => error);
    }

    getBuddies(){
      const url = `${getLocationOrigin()}/eagleeye/get_rm_and_cm/`;
     const options = {...defaultOptions};
     console.log('getTickets')

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({buddies_arr:data.result});
           // alert("fix");
       }).catch(error => error);
    }



    postUpdateTicket(details,props) {
        console.log(details)
        const url = `${getLocationOrigin()}/support/update_ticket/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                                            'id': details.id,
                                            'ticket_type': details.ticket_type,
                                            'comment': this.state.comment.trim(),
                                            'status': 'closed'
                                              });
        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(function(response){                     
              alert(response.Message);
              window.location.reload();
              // props.history.goBack();
          })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }

    postEditTicket(details,props) {
      console.log(details)
      const url = `${getLocationOrigin()}/support/update_ticket/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                                          'id': this.state.selected_ticket.id,
                                          'priority': details.priority,
                                          'assigned_to': details.assigned_to,
                                          'comment': this.state.comment.trim(),
                                          'status': 'edit'
                                            });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(function(response){                     
            alert(response.Message);
            window.location.reload();
            // props.history.goBack();
        })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }


    handleChange(event) {
        var value = event.target.value
        console.log('comment')
        console.log(value)
        value = value.trim()
        this.setState({comment: value});
        // this.getAmount(this.state.equipment_details)
    }

    handleEditChange(event) {
      const name = event.target.name;
      var new_value =  Object.assign({}, this.state.edit_details);
      new_value[name] = event.target.value
      this.setState({edit_details: new_value})
    }

    handleEdit(event) {
      console.log('Edit')
        event.preventDefault();
        console.log('Submit');
        if(this.state.comment && this.state.comment.trim().length > 10){
          this.postEditTicket(this.state.edit_details ,this.props)
        }
        else{
          alert('Please provide the reason')
        }
    }

    handleSubmit(event) {
        console.log('handle')
        event.preventDefault();
        console.log('Submit');
        if(this.state.comment && this.state.comment.trim().length > 10){
          this.postUpdateTicket(this.state.selected_ticket ,this.props)
        }
        else{
          alert('Please provide the solution before you submit')
        }
      }

    showOpenTickets(event) {
      var name = event.target.name;
      if(name === 'open'){
        this.setState({selected_values: this.state.open_tickets,is_open_ticket_checked:true})
      }
      else{
        this.setState({selected_values: this.state.close_tickets,is_open_ticket_checked:false})
      }
    }

    closeTicket(event){
      console.log('value')
      console.log(event.target.value)
      var id = event.target.value
      var open_tickets = this.state.open_tickets
      var ticket = open_tickets.find(temp => temp.id == id)
      console.log(ticket)
      this.setState({open_close_dialog:true,selected_ticket:ticket});
    }

    editTicket(event){
      console.log('edit')
      console.log(event.target.value)
      var id = event.target.value
      var open_tickets = this.state.open_tickets
      var ticket = open_tickets.find(temp => temp.id == id)
      var new_value =  Object.assign({}, this.state.edit_details);
      new_value['priority'] = ticket.priority
      new_value['assigned_to'] = ticket.assigned_to
      console.log(ticket)
      this.setState({open_edit_dialog:true,selected_ticket:ticket, edit_details: new_value});
    }

    showComment(id){
      // var id = event.target.value
      console.log('show Comments')
      console.log('id')
      // console.log(this.state.selected_values)
      var ticket = this.state.selected_values.find(temp => temp.id == id)
      this.setState({selected_ticket:ticket, open_comments_dialog:true})
    }

    getTrProps = (state, rowInfo, instance) => {
      if (rowInfo && this.state.is_open_ticket_checked) {
        return {
          style: {
            background: rowInfo.row._original.time_passed > 24 ? '#ffafbd ' : 'white',
            color: rowInfo.row._original.time_passed > 24 ? 'black' : 'black'
          }
        }
      }
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    }

  
    render() {
      console.log('amount')
      console.log(this.state.edit_details)
      console.log('TicketStatus props',this.props)

      if(this.state.venue != this.props.props.statsTable.revenue_per_month.requested_venue_id){
        this.locationChanged()
      }

      const dialog_actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Submit"
          primary={true}
          onClick={this.handleSubmit}
        />,
      ];  

      const dialog_edit = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleEditClose}
        />,
        <FlatButton
          label="Make Changes"
          primary={true}
          onClick={this.handleEdit}
        />,
      ];

      const dialog_ok = [
        <FlatButton
          label="OK"
          primary={true}
          onClick={this.handleCommentsClose}
        />
      ];  
      const data = this.state.selected_values;

      

      const open_columns = [{  
       Header: 'Name',  
       accessor: 'name'  
       },{  
       Header: 'Mobile Number',  
       accessor: 'mobile_no' ,
       minWidth: 100
       },{  
       Header: 'Ticket Type',  
       accessor: 'ticket_type_display'  
       },{  
       Header: 'Content',  
       accessor: 'content',
       Cell: ({row}) => (<span> {row.content.split("\n")[0]} </span>),
       minWidth: 250 
       },{  
       Header: 'Venue',  
       accessor: 'venue',
       minWidth: 100
       },
       {  
       Header: 'Priority',  
       accessor: 'priority', 
       Cell: cellInfo  => (<span className= {cellInfo.original.priority == 5 ?'badge badge-danger' : (cellInfo.original.priority == 4 ? 'badge badge-warning' : 'badge badge-default')} style={{color:'black'}}>{cellInfo.original.priority_display}</span>),
       minWidth: 80
       },
       {
       Header: 'Created',
       accessor: 'time_passed',
       Cell: ({ row }) => (<span>
        {
          row.time_passed > 0 ? (row.time_passed == 1 ? row.time_passed + ' Hour Ago' : (row.time_passed < 24 ? row.time_passed + ' Hours Ago': (Math.round(row.time_passed / 24) == 1 ? Math.round(row.time_passed / 24) + ' Day Ago' : Math.round(row.time_passed / 24) + ' Days Ago'))): 'Less than a hour ago'
        }
        </span>),
       minWidth: 80 
       },
       {  
       Header: 'Status',  
       accessor: 'status_display',
       minWidth: 50  
       },
       {
        Header: 'Comments',
        accessor: 'id',
        Cell: ({ row }) => (<i onClick={()=>{this.showComment(row.id)}} className='fa fa-comments-o fa-2x' style={{cursor:'pointer',display:'block',margin:'auto'}}/>),
        minWidth: 80
        },
       {
        Header: 'Edit',
        accessor: 'id',
        Cell: ({ row }) => (<button className='btn btn-primary' style={{display:'grid'}} value= {row.id} onClick={this.editTicket} >Edit</button>),
        minWidth: 60
        },
       {
        Header: 'Action',
        accessor: 'id',
        Cell: ({ row }) => (<button className='btn btn-primary' style={{display:'grid'}} value= {row.id} onClick={this.closeTicket} >Close Ticket</button>)
        }
       ];

       const close_columns =  [{  
       Header: 'Name',  
       accessor: 'name'  
       },{  
       Header: 'Mobile Number',  
       accessor: 'mobile_no',
       minWidth: 80
       },{  
       Header: 'Ticket Type',  
       accessor: 'ticket_type_display'  
       },{  
       Header: 'Content',  
       accessor: 'content',
       minWidth: 250  
       },{  
       Header: 'Venue',  
       accessor: 'venue',
       minWidth: 100 
       },{  
       Header: 'Priority',  
       accessor: 'priority_display',
       Cell: cellInfo => (<span className={cellInfo.original.priority == 5 ?'badge badge-danger' : (cellInfo.original.priority == 4 ? 'badge badge-warning' : 'badge badge-default')} style={{color:'black'}}>{cellInfo.original.priority_display}</span>),
       minWidth: 60  
       },{
       Header: 'Created',
       accessor: 'time_passed',
       Cell: ({ row }) => (<span>
        {
          row.time_passed > 0 ? (row.time_passed == 1 ? row.time_passed + ' Hour Ago' : (row.time_passed < 24 ? row.time_passed + ' Hours Ago': (Math.round(row.time_passed / 24) == 1 ? Math.round(row.time_passed / 24) + ' Day Ago' : Math.round(row.time_passed / 24) + ' Days Ago'))): 'Less than a hour ago'
        }
        </span>),
       minWidth: 80 
       },
       {  
       Header: 'Status',  
       accessor: 'status_display',
       minWidth: 50  
       },
       {
        Header: 'Comments',
        accessor: 'id',
        Cell: ({ row }) => (<i onClick={()=>{this.showComment(row.id)}} className='fa fa-comments-o fa-2x' style={{cursor:'pointer',display:'block',margin:'auto'}}/>),
        minWidth: 80
        }
       ]

      return(
        <div>
          <div style={{float:'right',margin:'10px',display:'flex'}}>
            <button className='btn btn-warning' name='open' style={{color:'black'}} onClick={this.showOpenTickets}>Open Tickets </button>
            <button className='btn btn-primary' name='close' onClick={this.showOpenTickets}>Closed Tickets </button>
          </div>
        
          <ReactTable  
            data={data}  
            className="-striped -highlight"
            columns={this.state.is_open_ticket_checked ? open_columns : close_columns}  
            defaultPageSize = {100}  
            pageSizeOptions = {[100,200,500]} 
            getTrProps={this.getTrProps} 
            filterable={true}
            showPagination={data.length > 100}
            showPaginationTop = {data.length > 100}
            style = {{background:'#9370DB'}}
            defaultFilterMethod = {(filter, row, column) => {
              const id = filter.pivotId || filter.id
              return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
            }}
          > 

            {
              //To show the record count on top  
              (state, makeTable, instance) => {

                let recordsInfoText = "";

                const { filtered, pageRows, pageSize, sortedData, page } = state;

                if (sortedData && sortedData.length > 0) {
                  let isFiltered = filtered.length > 0;

                  let totalRecords = sortedData.length;

                  let recordsCountFrom = page * pageSize + 1;

                  let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                  if (isFiltered){
                    recordsInfoText = `${totalRecords} filtered records`;
                  }
                  else {
                    recordsInfoText = `${totalRecords} records`;
                  }
                } else {
                    recordsInfoText = "No records";
                  }
                return (
                  <div className="main-grid">
                    <div className="above-table text-right">
                      <div className="col-sm-12 records-info">
                        <span className="">{recordsInfoText}</span>
                      </div>
                    </div>
                    {makeTable()}
                    
                  </div>

                );
              }
            }
          </ReactTable>
            

          {
            this.state.open_close_dialog ?

            <Dialog
                    actions={dialog_actions}
                    modal={false}
                    open={this.state.open_close_dialog}
                    onRequestClose={this.handleClose}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                    // scroll={scroll}
                    // dividers={scroll === 'paper'}
                  >

              <div style={{display:'flex',flexDirection:'column'}}>
                <div style={styles.main_header} className="col-md-12">
                  <h4 style={{textAlign:'center'}}> Close Ticket </h4>
                </div>
                <span style={{marginBottom:'10px'}}> Content of ticket </span>
                <pre> {this.state.selected_ticket.content} </pre>
                <span style={{marginBottom:'10px'}}> Please explain briefly about the solution provided </span>
                <textarea rows="5" onChange={this.handleChange}/>
              </div>
            </Dialog>
            :
            ""
          }

          {
            this.state.open_edit_dialog ?

            <Dialog
                    actions={dialog_edit}
                    modal={false}
                    open={this.state.open_edit_dialog}
                    onRequestClose={this.handleEditClose}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                    // scroll={scroll}
                    // dividers={scroll === 'paper'}
                  >
              <div style={{display:'flex',flexDirection:'column'}}>

                <div style={styles.main_header} className="col-md-12">
                  <h4 style={{textAlign:'center'}}> Edit Ticket </h4>
                </div>

                <div style={{display:'flex',flexDirection:'row',margin:'20px'}}>
                  <span style={{marginBottom:'10px'}}> Reassign ticket - </span>
                  <select name="assigned_to" className="col-md-6" style={{marginLeft:'15px'}}
                  onChange={this.handleEditChange} value={this.state.edit_details.assigned_to}>
                  <option key={0} value={null}></option>
                  {
                    this.state.buddies_arr.map((buddy, index) => (
                      <option key={buddy.id} value={buddy.id}>{buddy.name}</option>
                    ))
                  }
                </select>
                </div>

                <div style={{display:'flex',flexDirection:'row',margin:'20px'}}>
                  <span style={{marginBottom:'10px'}}> Change Priority - </span>
                  <select name="priority" className="col-md-6" value={this.state.edit_details.priority} style={{marginLeft:'15px'}}
                  onChange={this.handleEditChange}>
                  {
                    Object.keys(this.state.priority_arr).map((key, index) => (
                      <option key={index} value={key}>{this.state.priority_arr[key]}</option>
                    ))
                  }
                  </select>
                </div>

                <div style={{display:'flex',flexDirection:'column'}}>
                  <span style={{marginBottom:'10px'}}> Please state the reason for change </span>
                  <textarea rows="5" onChange={this.handleChange}/>
                </div>
              </div>
            </Dialog>
            :
            ""
          }

          {
            this.state.open_comments_dialog ?
              <Dialog
                    actions={dialog_ok}
                    modal={false}
                    open={this.state.open_comments_dialog}
                    onRequestClose={this.handleCommentsClose}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}>

                <div style={{display:'flex',flexDirection:'column'}}>
                    <div style={styles.main_header} className="col-md-12">
                      <h4 style={{textAlign:'center'}}> Comments Provided </h4>
                    </div>
                    <pre> {this.state.selected_ticket.comment} </pre>

                </div>
              </Dialog>
            :
            ""

          }
        </div>

          
        
      );
    }
  }
  
  export default TicketStatus;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/ticketStatus/index.js